module.exports = __webpack_public_path__ + "static/media/1POLICY7.6abfc7e1.jpg";